<div
  class="stepper-view"
  [ngClass]="{
    stepheight: stepheight,
    'estimation-stepper': page === 'estimation',
    'height-100': steps.length == 1
  }"
>
  <h2 tabindex="0" id="stepper-title" [ngClass]="{ 'mb-0': steps.length == 1 }">
    {{ title }}
  </h2>
  <div class="stepper-container" *ngIf="steps.length > 1">
    <ng-container *ngFor="let item of steps; let i = index; let last = last">
      <div class="step">
        <div
          class="outer-circle"
          [ngClass]="{
            'stepper-after': i === 0 || (i != 0 && !last),
            'stepper-before': i != 0,
            'stepper-complete':
              item.completed || (last && steps[i - 1].completed),
            'stepper-complete1':
              i != 0 &&
              !last &&
              steps[i - 1].completed &&
              !steps[i + 1].completed &&
              !item.completed
          }"
        >
          <div
            class="step-circle"
            [ngClass]="{
              'active-step': item.active,
              'complete-step': item.completed
            }"

            [class.transparent]="item.active && !item.completed && transparent"

          >
            <span class="stepperMedia">
              <span class="step-number">
                <span *ngIf="!item.completed"> {{ i + 1 }}</span>
                <span *ngIf="item.completed">
                  <img src="./assets/icons/tick_white.svg" alt="tick-icon" />
                </span>
              </span>
            </span>
          </div>
        </div>
        <div class="step-text-block stepperMedia">
          <p
            class="step-text"
            #stepperText
            [class.active-step-text]="item.completed || item.active"
          >
            {{ item.stepValue | translate }}
          </p>
        </div>
        <div
          class="step-divider"
          [ngClass]="{
            'first-step': i == 0,
            'last-step': last,
            'complete-1':
              i != 0 &&
              !last &&
              steps[i - 1].completed &&
              !steps[i + 1].completed &&
              !item.completed
          }"
          [class.complete]="item.completed || (last && steps[i - 1].completed)"
        ></div>
      </div>
      <div class="step" *ngIf="(i === 0 && steps.length == 2) || i === 0 && steps.length == 3 || i === 1 && steps.length == 3"  >
        <div
          class="step-divider"
          [ngClass]="{
            'complete-1':
              i != 0 && i != 1 &&
              !last &&
              steps[i - 1].completed &&
              !steps[i + 1].completed &&
              !item.completed
          }"
          [class.complete]="item.completed || (last && steps[i - 1].completed)"
        ></div>
      </div>
      <div class="step" *ngIf="i === 0 && steps.length == 2">
        <div
          class="step-divider"
          [ngClass]="{
            'complete-1':
              i != 0 &&
              !last &&
              steps[i - 1].completed &&
              !steps[i + 1].completed &&
              !item.completed
          }"
          [class.complete]="item.completed || (last && steps[i - 1].completed)"
        ></div>
      </div>
    </ng-container>
  </div>
</div>
